import type { ColorType, SizeType, State } from "@/abc-dsk/options";

export const CLASS_NAME_COMPONENT = "tg-button";

export enum Variant {
  Solid = "solid",
  Outline = "outline",
  Text = "text"
}

type Modifiers = {
  color: ColorType | "white";
  size: SizeType;
  sizeSm: SizeType;
  sizeMd: SizeType;
  sizeLg: SizeType;
  sizeXl: SizeType;
  sizeXxl: SizeType;
};

type ModifiersWithState = Modifiers & {
  state: State;
};

export const createBlockClasses = (
  blockName: string,
  { color, size, sizeSm, sizeMd, sizeLg, sizeXl, sizeXxl, state }: ModifiersWithState
) => {
  let colorSizeVariant = `${blockName}--${color}-${size}`;
  let colorVariant = `${blockName}--${color}`;

  if (state) {
    colorSizeVariant += `-${state}`;
    colorVariant += `-${state}`;
  }

  return [
    blockName,
    `${blockName}--size-xs-${size}`,
    `${blockName}--size-sm-${sizeSm}`,
    `${blockName}--size-md-${sizeMd}`,
    `${blockName}--size-lg-${sizeLg}`,
    `${blockName}--size-xl-${sizeXl}`,
    `${blockName}--size-xxl-${sizeXxl}`,
    `${blockName}--${color}`,
    colorSizeVariant,
    colorVariant
  ];
};

export const createContentClasses = (
  elementName: string,
  { color, size, sizeSm, sizeMd, sizeLg, sizeXl, sizeXxl }: Modifiers
) => [
  elementName,
  `${elementName}--${color}`,
  `${elementName}--size-xs-${size}`,
  `${elementName}--size-sm-${sizeSm}`,
  `${elementName}--size-md-${sizeMd}`,
  `${elementName}--size-lg-${sizeLg}`,
  `${elementName}--size-xl-${sizeXl}`,
  `${elementName}--size-xxl-${sizeXxl}`
];
